import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AdapterOptions } from '../../../../../adapters/types'
import { RocFormData } from '../../../../types/RocFormData'
import { RocFormField } from '../../../../types/RocFormField'
import { RocAssessmentQuestionnaireItem } from '../../../../types/questionnaire'
import { getAnswerValuesFromItems } from '../../../../../helpers'
import { BaseSubsectionAdapter } from '../../../../../adapters/BaseSubsectionAdapter'
import { FlatAnswerMutation } from '../../../../../adapters/types'

/**
 * Musculoskeletal subsection adapter
 * Handles musculoskeletal system assessment (2 fields - simplest after Lines/Drains)
 */
export class MusculoskeletalAdapter extends BaseSubsectionAdapter<RocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RocFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Musculoskeletal assessment fields
    const musculoskeletalAssessment = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_MUSCULOSKELETAL_ASSESSMENT
    )

    const systemSummary = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_SYSTEM_SUMMARY
    )?.at(0)

    return {
      [RocFormField.MUSCULOSKELETAL_ASSESSMENT]: musculoskeletalAssessment,
      [RocFormField.MUSCULOSKELETAL_SYSTEM_SUMMARY]: systemSummary
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(RocFormField.MUSCULOSKELETAL_ASSESSMENT)) {
      mutations.push({
        linkId:
          RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_MUSCULOSKELETAL_ASSESSMENT,
        value: this.getFormDataField(RocFormField.MUSCULOSKELETAL_ASSESSMENT)
      })
    }

    if (this.formDataFieldExists(RocFormField.MUSCULOSKELETAL_SYSTEM_SUMMARY)) {
      mutations.push({
        linkId: RocAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_MUSCULOSKELETAL_SYSTEM_SUMMARY,
        value: this.getFormDataField(RocFormField.MUSCULOSKELETAL_SYSTEM_SUMMARY)
      })
    }

    return mutations
  }
}
